export const contentTermsCondition = {
  marginTop: {
    xs: '105px', phoneMd: '105px', sm: '105px', md: '78px', lg: '78px', xl: '78px',
  },
  marginBottom: '60px',
};
